/**
 * Created on 25/8/19.
 */
// export default {
//     headerRow: ['% of Sq Ft', 'Start', 'End',  'Annual Rent', 'PSF', 'Escalation Date', 'Escalation Amount', 'Options','Option #1 Rent', 'Lease Type'],
//     rows: {'no-row': {valueCells: []}}
// }

export default {
    headerRow: ['% of Sq Ft', 'Start', 'End',  'Annual Rent', 'PSF', 'Escalation Date', 'Escalation Amount','Escalation PSF', 'Options','Option #1 Rent', 'Lease Type'],
    rows: {'no-row': {valueCells: []}}
}